import { Components } from '@mui/material';

export function getMuiOutlinedInput(): Components['MuiOutlinedInput'] {
  return {
    styleOverrides: {
      root: {
        fontSize: 24,
      },

      input: {
        padding: 0,
      },

      notchedOutline: {
        border: 0,
      },
    },
  };
}
